import ToastNotificationInterface, { ToastNotificationType } from "@app/Interface/ToastNotificationInterface";

export default class ToastNotificationModel implements ToastNotificationInterface {
    
    public id: number;
    public title: string;
    public description: string;
    public type: ToastNotificationType;

    constructor() {
        this.id = 0;
        this.title = "";
        this.description = "";
        this.type = ToastNotificationType.Default;
    }
    

}